import { useState } from 'react';
import { Shield, FileText, Trash2, Lock } from 'lucide-react';
import ProcedureSetupTab from '../components/cutover/ProcedureSetupTab';
import ClinicDeactivationTab from '../components/cutover/ClinicDeactivationTab';
import SecurityTab from '../components/cutover/SecurityTab';
import UserPagePermissionsTab from '../components/cutover/UserPagePermissionsTab';
import './AdminCutoverPage.css';

type AdminTab = 'procedures' | 'deactivation' | 'security' | 'pageAccess';

export default function AdminPage() {
  const [activeTab, setActiveTab] = useState<AdminTab>('procedures');

  return (
    <div className="acp">
      <div className="acp-header">
        <div className="page-title-row">
          <Shield size={28} />
          <h1>Admin Tools</h1>
        </div>
        <p className="acp-subtitle">Procedure setup, security, and access management</p>
      </div>

      <div className="acp-tabs">
        <button
          type="button"
          className={`acp-tab ${activeTab === 'procedures' ? 'active' : ''}`}
          onClick={() => setActiveTab('procedures')}
        >
          <FileText size={16} />
          <span>Procedure Setup</span>
        </button>
        <button
          type="button"
          className={`acp-tab ${activeTab === 'deactivation' ? 'active' : ''}`}
          onClick={() => setActiveTab('deactivation')}
        >
          <Trash2 size={16} />
          <span>Clinic Deactivation</span>
        </button>
        <button
          type="button"
          className={`acp-tab ${activeTab === 'security' ? 'active' : ''}`}
          onClick={() => setActiveTab('security')}
        >
          <Shield size={16} />
          <span>Security</span>
        </button>
        <button
          type="button"
          className={`acp-tab ${activeTab === 'pageAccess' ? 'active' : ''}`}
          onClick={() => setActiveTab('pageAccess')}
        >
          <Lock size={16} />
          <span>Page Access</span>
        </button>
      </div>

      <div className="acp-content">
        {activeTab === 'procedures' && <ProcedureSetupTab />}
        {activeTab === 'deactivation' && <ClinicDeactivationTab />}
        {activeTab === 'security' && <SecurityTab />}
        {activeTab === 'pageAccess' && <UserPagePermissionsTab />}
      </div>
    </div>
  );
}
